<template>
    <div class="trading-desk-container basket-container">
        <v-layout column wrap fill-height>
            <div class="collections-container thankyou-wrapper">
                <div class="thankyou-img"></div>
                <h2>Thank you!</h2>
                <div class="additional-info">Your invoice(s) has been successfully paid.</div>
                <div class="btn-primary" v-on:click="$router.push(localePath({ path: '/my-account/invoices'}))">Go to my
                    invoices
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>

export default {
    name: "SuccessCollectionTripleA",
    head() {
        return {
            title: 'Successful TripleA payment | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                },
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex'
                }
            ],
            bodyAttrs: {
                class: 'payment-page'
            }
        }
    },
    mounted() {
        this.$gtm.push({ event: "AllPurchases" });
    }
}
</script>

<style scoped>
.basket-container {
    padding: 100px calc(3 * var(--gutter)) calc(1.2 * var(--gutter));
    height: calc(100% - 413px);
}

.thankyou-img {
    background: url('../assets/v_dark.svg') no-repeat center;
    background-size: contain;
    width: 300px;
    height: 250px;
    margin: 0 auto;
}

.thankyou-wrapper {
    text-align: center;
    padding-bottom: 100px;
}

.additional-info {
    max-width: 1024px;
    margin: 30px auto;
    font-weight: 300;
}

.thankyou-wrapper .btn-primary {
    margin: 48px 0 32px;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFF;
    z-index: 99999;
    top: 0;
    left: 0;
}

.loading-gif {
    margin: 200px auto;
    width: 200px;
    height: 200px;
}
</style>

<style>
.cc_dialog.headline,
.payment-page #iubenda-cs-banner {
    display: none !important;
}
</style>
